<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" filterable
                        @change="inputChange">
                        <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否确认：">
                    <el-select v-model="formInline.isConfirm" placeholder="请选择是否确认" clearable size="small"
                        @change="inputChange">
                        <el-option label="全部" :value="null"></el-option>
                        <el-option label="已确认" :value="true"></el-option>
                        <el-option label="未确认" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="this.$checkBtnPermission('/storeCost/appropriation', 'viewPage')" size="small"
                        type="primary" class="el-icon-search" @click="inputChange()">
                        搜索
                    </el-button>
                    <el-button v-if="this.$checkBtnPermission('/storeCost/appropriation', 'create')" size="small"
                        type="primary" class="el-icon-plus" @click="handleEdit()">新增
                    </el-button>
                </el-form-item>
            </el-form>
            <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" border stripe
                @rowDBClick="handleEdit">
                <el-table-column slot="isConfirm" label="是否确认" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isConfirm" type="success">已确认</el-tag>
                        <el-tag v-else type="danger">未确认</el-tag>
                    </template>
                </el-table-column>
            </STable>
            <!-- 分页组件 -->
            <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </topTab>
        <!-- 编辑 -->
        <edit ref="edit"></edit>
    </div>
</template>

<script>
import {
    GetStoreAppropriationPageList
} from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import edit from "./edit.vue";
export default {
    data() {
        return {
            activeTab: "1",
            tabData: [
                {
                    key: "1",
                    value: "备用金下拨",
                },
            ],
            pageShow: true,
            loading: false, // 显示加载
            listData: [],
            selectionList: [],
            // 分页参数
            pageparm: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
            formInline: {
                pageIndex: 1,
                pageSize: 10,
                storeKeyId: "",
                isConfirm: null
            },
            storeList: [],
            columnsData: [], //显示列
            listColumns: [
                {
                    prop: "rowNumber",
                    label: "序号",
                    align: "center",
                    fixed: "left",
                    width: "80",
                    isKeep: true,
                },
                {
                    prop: "createTime",
                    label: "经办时间",
                    width: "170",
                    align: "center",
                },
                {
                    prop: "confirmTime",
                    label: "确认时间",
                    align: "center",
                    width: "170",
                },
                {
                    prop: "storeName",
                    label: "门店名称",
                    isKeep: true,
                    minWidth: "120",
                    align: "center",
                },
                {
                    prop: "money",
                    label: "下拨备用金",
                    minWidth: "100",
                    align: "center",
                },
                {
                    slot: "isConfirm",
                    label: "是否确认",
                    minWidth: "120",
                    align: "center",
                },
                {
                    prop: "confirmUserName",
                    label: "确认人",
                    align: "center",
                },
                {
                    prop: "creator",
                    label: "经办人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "employeeName",
                    label: "收款人",
                    width: "120",
                    align: "center",
                },
            ],
        };
    },
    // 注册组件
    components: {
        edit,
    },
    created() {
        // 初始列
        this.getCheckBox(this.listColumns.map((item) => item.label));
        this.getListData();
        this.GetOrgInfoListByConfig();
    },
    computed: {},
    methods: {
        // 获取筛选框
        getCheckBox(val) {
            let arr = this.listColumns.filter((v) => !val.includes(v.label));
            this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
        },
        changePages() { },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.storeList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        //显示编辑界面
        handleEdit(row) {
            this.$refs.edit.editShow(row);
        },
        // 获取列表
        getListData() {
            this.loading = true;
            GetStoreAppropriationPageList(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data;
                        this.pageparm.total = res.totalNumber;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                });
        },
        inputChange(val) {
            this.search();
        },
        // 分页插件事件
        callFather(parm) {
            if (parm.currentPage == undefined) {
                this.formInline.pageIndex = 1;
            } else {
                this.formInline.pageIndex = parm.currentPage;
            }
            this.formInline.pageSize = parm.pageSize;
            this.getListData();
        },
        // 搜索事件
        search() {
            this.formInline.pageIndex = 1;
            this.pageShow = false;
            this.$nextTick(() => {
                this.pageShow = true;
            });
            this.getListData();
        },
    },
};
</script>

<style scoped></style>